import React from "react";
import { whatToMonitorOptions } from "./MonitoringSetup";
import { Dropdown } from "react-bootstrap";
import MyDropdownButton from "../Common/MyDropdownButton";
import HelpButton from "../HelpContent/HelpButton";

export default function MonitorOptions({
  whatToMonitor,
  setWhatToMonitor,
  disabled,
}) {
  return (
    <div className="">
      <div className="mb-3">
        <span className="fs-4 fw-bold ms-2">
          What would you like to monitor?
          <HelpButton helpKey="monitoring-what-to-monitor"/>
        </span>
      </div>
      <div className="mb-3">
        <Dropdown>
          <Dropdown.Toggle
            id="dropdown-what-monitor"
            className="bg-white text-black w-100 border-0 d-flex justify-content-between align-items-center text-start p-2 rounded-3"
            disabled={disabled}
          >
            {whatToMonitor ? (
              <MyDropdownButton option={whatToMonitor} />
            ) : (
              <div className="fw-bold text-start fs-5">Please select...</div>
            )}
          </Dropdown.Toggle>

          <Dropdown.Menu className="bg-purple-gradient">
            {whatToMonitorOptions.map((o) => (
              <Dropdown.Item
                href="#/action-1"
                className={`border-bottom${o.isDisabled ? " opacity-50" : ""}`}
                disabled={o.isDisabled}
                key={o.name}
              >
                <button
                  type="button"
                  className={`btn mb-2 rounded-4 text-start `}
                  onClick={(e) => {
                    e.preventDefault();
                    setWhatToMonitor(o);
                  }}
                >
                  <MyDropdownButton option={o} />
                  {/* {whatToMonitor?.info && (
                    <div className="bg-white rounded-3 p-3 ">
                      {whatToMonitor?.info}
                    </div>
                  )} */}
                </button>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
}
